<template>
  <div>
    <section>
        <div class="container">
            <figure><img src="/static/images/index/i80banner.png" class="img-responsive"></figure>
        </div>
    </section>
    <section>
        <div class="container">
            <ol class="breadcrumb hidden-xs">
                <li><a href="/">首頁</a></li>
                <li><a href="#">購物車</a></li>
                <li class="active">訂購商品</li>
            </ol>
            <div class="step_list text-center">
                <ol class="list-inline step hidden-xs">
                    <li><a href="#">1. 購物明細</a></li>
                    <li><a href="#">2. 付款方式</a></li>
                    <li class="active"><a href="#">3. 完成訂購</a></li>
                </ol>
            </div>
            <form action="https://store.i80.com.tw/Trans.php" id="order-form" method="POST">
            <div class="row" v-show="step1">
                <div class="col-sm-offset-2 col-sm-8">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-4 control-label">
                                    <span class="label label-default">物流方式</span>
                                </label>
                                <div class="col-sm-8">
                                    <select class="form-control" name="delivery" v-model="shippinged">
                                        <option v-for="option in shippingOptions" v-bind:value="option.tx">{{option.text}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-4 control-label">
                                    <span class="label label-default">發票開立方式</span>
                                </label>
                                <div class="col-sm-8">
                                    <select class="form-control" name="invoice" v-model="invoiced">
                                        <option v-for="option in invoiceOptions" v-bind:value="option.value">
                                            {{option.text}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--invoice-->
                    <div class="row" v-show="invoiceShow">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label">
                                    <h5 class="title">統一編號</h5>
                                </label>
                                <div class="col-sm-6">
                                    <input type="text" name="invoice_number" class="form-control" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label">
                                    <h5 class="title">抬頭</h5>
                                </label>
                                <div class="col-sm-6">
                                    <input type="text" name="invoice_company" class="form-control"  />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="cart_list">
                        <div class="cart_head">
                            <div class="row">
                                <div class="col-sm-2 hidden-xs"><h5 class="title">商品圖片</h5></div>
                                <div class="col-sm-2 col-xs-3"><h5 class="title">商品名稱</h5></div>
                                <div class="col-sm-1 col-xs-1"><h5 class="title">單價</h5></div>
                                <div class="col-sm-1 col-xs-1"><h5 class="title">點數</h5></div>
                                <div class="col-sm-1 col-xs-1"><h5 class="title">數量</h5></div>
                                <div class="col-sm-2 col-xs-2"><h5 class="title">點數小計</h5></div>
                                <div class="col-sm-2 col-xs-2"><h5 class="title">單價小計</h5></div>
                                <div class="col-sm-1 col-xs-1"><h5 class="title">刪除</h5></div>
                            </div>
                        </div>
                        <div class="list_item" v-for="(item, index) in items">
                            <div class="row">
                                <div class="col-sm-2 hidden-xs">
                                    <figure><img :src="'https://files.i80.com.tw/images/product/'+item.imageL" class="img-responsive"/></figure>
                                </div>
                                <div class="col-sm-2 col-xs-3"><h5 class="title">{{ item.name }} </h5></div>
                                <div class="col-sm-1 col-xs-1"><span>{{ item.price }} </span></div>
                                <div class="col-sm-1 col-xs-1"><span>{{ item.point }} </span></div>
                                <div class="col-sm-1 col-xs-1">
                                    <select v-model="item.quantity">
                                        <option v-for="number in item.maximum" :value="number">{{ number }}</option>
                                    </select>
                                </div>
                                <div class="col-sm-2 col-xs-2"><span>{{ item.point*item.quantity }}</span></div>
                                <div class="col-sm-2 col-xs-2"><span>{{ item.price*item.quantity }}</span></div>
                                <!---<div class="col-sm-1"><h5 class="title" @click="DELETE_TO_CART(item)">刪除</h5></div>-->
                                <div class="col-sm-1 col-xs-1"><h5 class="title" @click="DELETE_TO_CART(item)"><span class="glyphicon glyphicon-trash"></span></h5></div>
                            </div>
                        </div>
                        <hr/>
                        <!-- 加購專區 -->
                        <div v-if="totalPoint>=1000">
              						<h4 class="title">加購專區</h4>
              						<div class="row">
              							<div class="col-md-3 col-sm-3 col-xs-3" v-for="(item, index) in addon">
              								<div class="product_box">
              										<a v-bind:href="'/product/'+item.id">
              											<figure class="pic">
              												<img :src="'https://files.i80.com.tw/images/product/'+item.imageM" class="img-responsive">
              											</figure>
              										</a>
              										<h5 class="title">{{item.name}}</h5>
              										<p class="price">{{item.price}}</p>
              										<button class="addcart btn btn-default i80_btn" type="button"  @click="addToCart(item)">
              											<span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span> 加入購物車
              										</button>
              								</div>
              							</div>
              						</div>
                        </div>

                        <div class="total_list">
                            <div class="row">
                                <div class="col-sm-offset-7 col-sm-5 col-xs-12">
                                    <p>共{{cart_items}}件，回饋點數: {{totalPoint}}點</p>
                                </div>
                                <div class="col-sm-offset-7 col-sm-2 col-xs-6"><p>小計</p></div>
                                <div class="col-sm-3 col-xs-6"><p><span>{{orderAmount}}</span></p></div>
                                <div class="col-sm-offset-5 col-sm-2 text-right hidden-xs"><p>(運費類型)</p></div>
                                <div class="col-sm-2 col-xs-6"><p>運費</p></div>
                                <div class="col-sm-3 col-xs-6"><p><span>{{shippingFee}}</span></p></div>
                                <div class="col-sm-offset-7 col-sm-2 col-xs-6"><p>稅金</p></div>
                                <div class="col-sm-3 col-xs-6"><p><span>{{invoiceFee}}</span></p></div>
                                <div class="col-sm-offset-7 col-sm-2 col-xs-6">
                                    <span class="label label-danger">總計</span>
                                </div>
                                <div class="col-sm-3 col-xs-6"><span>{{totalAmount}}</span></div>
                            </div>
                        </div>
                    </div>
                    <h5 class="title">注意事項</h5>
                    <ol class="notice_list">
                        <li>請確認您填寫的資料是否正確，一旦訂單完成後，付款與物流方式皆無法修改。</li>
                        <li>出貨方式，按照訂購區域與時間，依序進行出貨/排貨。</li>
                        <li>若您對取貨或付款的方式有疑問，請詳閱「購物須知」。</li>
                    </ol>
                    <div class="text-center">
                    <button class="btn btn-info" type="button" @click="nextStep()">下一步</button>
                    </div>
                </div>
            </div>

            <!--步驟二-->
            <div class="row" v-show="step2">
                <div class="col-sm-offset-2 col-sm-8">
                    <div class="payment">
                        <div class="alert alert-info" role="alert">付款方式</div>
                        <div>
                            <label>
                                <input type="radio" name="payment" value="1" v-model="paymented"/>
                                ATM轉帳：使用實體ATM轉帳，手續費 15元
                            </label>
                        </div>
                        <div>
                            <label>
                                <input type="radio" name="payment" value="2" v-model="paymented"/>
                                網路ATM：需備有讀卡機，手續費 15元
                            </label>
                        </div>
                        <div>
                            <label>
                                <input type="radio" name="payment" value="3" v-model="paymented"/>
                                信用卡：手續費 2.75%
                            </label>
                        </div>
                        <div>
                            <label>
                                <input type="radio" name="payment" value="4" v-model="paymented"/>
                                超商付款：7-11 iBon付款，手續費 20元
                            </label>
                        </div>
                        <div>
                            <label>
                                <input type="radio" name="payment" value="5" checked v-model="paymented"/>
                                貨到付款
                            </label>
                        </div>
                    </div>
                    <div class="cart_list">
                        <div class="alert alert-info" role="alert">購物明細</div>
                        <div class="cart_head">
                            <div class="row">
                                <div class="col-sm-2 hidden-xs"><h5 class="title">商品圖片</h5></div>
                                <div class="col-sm-2 col-xs-3"><h5 class="title">商品名稱</h5></div>
                                <div class="col-sm-1 col-xs-1"><h5 class="title">單價</h5></div>
                                <div class="col-sm-1 col-xs-1"><h5 class="title">點數</h5></div>
                                <div class="col-sm-1 col-xs-1"><h5 class="title">數量</h5></div>
                                <div class="col-sm-2 col-xs-2"><h5 class="title">點數小計</h5></div>
                                <div class="col-sm-2 col-xs-2"><h5 class="title">單價小計</h5></div>
                            </div>
                        </div>
                        <div class="list_item" v-for="(item, index) in items">
                            <div class="row">
                                <div class="col-sm-2 hidden-xs">
                                    <figure><img :src="'https://files.i80.com.tw/images/product/'+item.imageL" class="img-responsive"/></figure>
                                </div>
                                <div class="col-sm-2 col-xs-3"><h5 class="title">{{ item.name }} </h5></div>
                                <div class="col-sm-1 col-xs-1"><span>{{ item.price }} </span></div>
                                <div class="col-sm-1 col-xs-1"><span>{{ item.point }} </span></div>
                                <div class="col-sm-1 col-xs-1"><span>{{ item.quantity }} </span></div>
                                <div class="col-sm-2 col-xs-2"><span>{{ item.point*item.quantity }}</span></div>
                                <div class="col-sm-2 col-xs-2"><span>{{ item.price*item.quantity }}</span></div>
                                <input type="hidden" name="pid[]" :value="item.id" >
                                <input type="hidden" name="qty[]" :value="item.quantity" >
                            </div>

                        </div>
                        <hr/>
                        <div class="discount" v-if="UserCash > 0">
                            <div class="row">
                                <div class="col-sm-offset-4 col-sm-8">
                                    <div class="form-group">
                                        <label for="inputDiscount" class="col-sm-2 col-xs-3 label label-danger text-right">使用回饋金</label>
                                        <div class="col-sm-4 col-xs-5">
                                            <input type="number" class="form-control" :disabled="discountInput == 1 ? true : false" v-model="discount" placeholder="請輸入扣抵金額"/>
                                        </div>
                                        <div class="col-sm-5 col-xs-3">
                                            <button type="button" class="btn btn-sm btn-success" @click="usedDiscount()" :disabled="discountInput == 1 ? true : false">確認扣抵</button>
                                            餘額: {{UserCash}} 元
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="total_list">

                            <div class="row">
                                <div class="col-sm-offset-7 col-sm-5 col-xs-12">
                                  <p>共 {{cart_items}} 件，回饋點數: {{totalPoint}} 點</p>
                                </div>
                                <div class="col-sm-offset-7 col-sm-2 col-xs-4"><p>小計</p></div>
                                <div class="col-sm-3 col-xs-8">
                                    <p><span>{{orderAmount}}</span></p>
                                </div>
                                <div class="col-sm-offset-7 col-sm-2 col-xs-4"><p>回饋金折抵</p></div>
                                <div class="col-sm-3 col-xs-8">
                                  <p><span>{{discount || 0}}</span></p>
                                </div>

                                <div class="col-sm-offset-5 col-sm-2 hidden-xs text-right"><p>(運費類型)</p></div>
                                <div class="col-sm-2 col-xs-4"><p>運費</p></div>
                                <div class="col-sm-3 col-xs-8"><p><span>{{shippingFee}}</span></p></div>

                                <div class="col-sm-offset-5 col-sm-2 hidden-xs text-right"><p>(金流類型)</p></div>
                                <div class="col-sm-2 col-xs-4"><p>手續費</p></div>
                                <div class="col-sm-3 col-xs-8"><p><span>{{paymentFee}}</span></p></div>

                                <div class="col-sm-offset-7 col-sm-2 col-xs-4"><p>稅金</p></div>
                                <div class="col-sm-3 col-xs-8"><p><span>{{invoiceFee}}</span></p></div>

                                <div class="col-sm-offset-7 col-sm-2 col-xs-3">
                                    <span class="label label-danger">總計</span>
                                </div>
                                <div class="col-sm-3 col-xs-3"><p><span>{{totalAmount}}</span></p></div>
                                <input type="hidden" name="shippingFee" v-model="shippingFee">
                                <input type="hidden" name="invoiceFee" v-model="invoiceFee">
                                <input type="hidden" name="firstbuy" v-model="firstbuy">
                            </div>
                        </div>
                    </div>
                    <div class="alert alert-info" role="alert">收件人資訊</div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label for="name" class="col-sm-3 control-label input_required">姓名</label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control" name="name" v-model="userName">
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="inputEmail" class="col-sm-3 control-label">Email</label>
                                <div class="col-sm-9">
                                    <input type="email" class="form-control" name="email" v-model="userEmail">
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="inputTime" class="col-sm-3 control-label">配送時間</label>
                                <div class="col-sm-9">
                                    <select name="time" class="form-control">
                                        <option value="不限時間">不限時間</option>
                                        <option value="上午">上午</option>
                                        <option value="下午">下午</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label for="inputConPhone" class="col-sm-3 control-label input_required">電話</label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control" name="phone" v-model="UserPhone">
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="inputCoAdd" class="col-sm-3 control-label">地址</label>
                                <div class="col-sm-4">
                                    <select class="form-control" name="county" v-model="countyval">
                                        <option v-for="option in county" v-bind:value="option.value" :selected="option.val == countyval">
                                            {{option.text}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-sm-4">
                                    <select class="form-control" name="district" v-model="districtval">
                                        <option v-for="option in district" v-bind:value="option.value" :selected="option.val == districtval">
                                            {{option.text}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-sm-12">
                                    <input type="text" class="form-control" name="address" v-model="UserAddress">
                                </div>
                            </div>

                        </div>
                        <input type="hidden" name="use_cash" v-model="discount">
                        <input type="hidden" name="token" v-model="token">
                        <input type="hidden" name="id" v-model="userID">
                    </div>

                    <h5 class="title">備註</h5>
                    <div class="form-group">
                        <textarea class="form-control" name="remark" placeholder="備註" rows="5"></textarea>
                    </div>
                    <h5 class="title">注意事項</h5>
                    <ol class="notice_list">
                        <li>請確認您填寫的資料是否正確，一旦訂單完成後，付款與物流方式皆無法修改。</li>
                        <li>出貨方式，按照訂購區域與時間，依序進行出貨/排貨。</li>
                        <li>若您對取貨或付款的方式有疑問，請洽本公司客服電話。</li>
                    </ol>
                    <div class="text-center">
                        <button type="button" class="btn btn-success" @click="onSubmit()" :disabled="this.flag">送出</button>
                    </div>
                </div>
            </div>
            <!--步驟二結束-->
            </form>
        </div>
    </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'ShoppingCart',
  data () {
    return {
      token: this.$store.getters.getToken,
      userID: this.$store.getters.getUserID,
      userName: '',
      userEmail: this.$store.getters.getUserEmail,
      UserPhone: this.$store.getters.getUserPhone,
      userCounty: this.$store.getters.userCounty,
      userDistrict: this.$store.getters.userDistrict,
      UserAddress: this.$store.getters.getUserAddress,
      UserCash: 0,
      // UserValid: this.$store.getters.getUserValid,
      items: this.$store.getters.getCart,
      firstbuy: this.$store.getters.getFirstbuy,
      numbers: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20
      ],
      invoiced: 1,
      invoiceFee: 0,
      invoiceOptions: [
        { text: '不需發票', value: 1 },
        { text: '二聯式發票', value: 2 },
        { text: '三聯式發票', value: 3 }
      ],
      shippinged: 'option',
      shippingFee: 0,
      shippingOptions: [],
      paymented: 5,
      paymentFee: 0,
      step1: true,
      step2: false,
      orderTotal: 0,
      discount: null,
      discountInput: false,
      invoiceShow: false,
      current_discount: 0,
      countyval: '',
      county: this.$store.getters.getCounty,
      districtData: this.$store.getters.getDistrict,
      district: [],
      districtval: this.$store.getters.getUserDistrict,
      addon: this.$store.getters.getAddon,
      flag: false,
      freeDelivery: 2000,
      free_delivery_set: 0,
      deliveryPricing: {}
    }
  },
  computed: {
    ...mapGetters([
      'getCart',
      'getUserID',
      'getUserName',
      'getUserEmail',
      'getCounty',
      'getDistrict',
      'getAddon',
      'getCompanies'
    ]),
    orderAmount () {
      let total = 0
      let invoice = this.invoiced
      if (this.items) {
        total = this.items.reduce((prev, element) => prev + element.price * element.quantity, 0)
      }
      switch (invoice) {
        case 1:
          this.invoiceFee = 0
          break
        case 2:
          this.invoiceFee = Math.ceil(total * 0.05)
          break
        case 3:
          this.invoiceFee = Math.ceil(total * 0.05)
          break
      }
      this.orderTotal = total
      return total
    },
    totalPoint () {
      return this.items.reduce((prev, element) => prev + element.point * element.quantity, 0)
    },
    cart_items () {
      let total = 0
      if (this.items) {
        total = this.items.length
      }
      return total
    },
    getInvoiceFee () {
      let invoice = this.invoiced
      let total = this.orderTotal
      switch (invoice) {
        case 2:
          this.invoiceFee = Math.ceil(total * 0.05)
          break
        case 3:
          this.invoiceFee = Math.ceil(total * 0.05)
          break
      }
    },
    totalAmount () {
      let total = parseInt(this.orderTotal)
      let invoiceFee = parseInt(this.invoiceFee)
      let shippingFee = parseInt(this.shippingFee)
      let paymentFee = parseInt(this.paymentFee)
      return total + invoiceFee + shippingFee + paymentFee - this.current_discount
    }
  },
  watch: {
    countyval: {
      handler: function (val, oldVal) {
        this.district = this.districtData[val - 1]
      },
      deep: true
    },
    items: {
      handler: function (val, oldVal) {
        let data = val
        this.$store.dispatch('EDIT_TO_CART', data)
        this.changeDelivery()
      },
      deep: true
    },
    shippinged: {
      handler: function (val, oldVal) {
        switch (val) {
          case 'logistics':
            this.shippingFee = this.deliveryPricing.c_domestic
            break
          case 'post':
            this.shippingFee = this.deliveryPricing.p_domestic
            break
          case 'help_yourself':
            this.shippingFee = 0
            break
          case 'send_to_home':
            this.shippingFee = this.deliveryPricing.c_domestic
            break
          case 'send_to_home_free':
            this.shippingFee = 0
            break
          default:
            this.shippingFee = 0
            break
        }
      }
    },
    invoiced: {
      handler: function (val, oldVal) {
        if (val === 3) {
          this.invoiceShow = true
        } else {
          this.invoiceShow = false
        }
      }
    },
    paymented: {
      handler: function (val, oldVal) {
        switch (val) {
          case '1':
            this.paymentFee = 15
            break
          case '2':
            this.paymentFee = 15
            break
          case '3':
            let total = this.orderTotal
            this.paymentFee = Math.ceil(total * 0.0275)
            break
          case '4':
            this.paymentFee = 20
            break
          case '5':
            this.paymentFee = 0
            break
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'DELETE_TO_CART',
      'EDIT_TO_CART',
      'ADD_TO_CART',
      'CHECKOUT'
    ]),
    getTotal () {
      return this.items.reduce((prev, element) => prev + element.price * element.quantity, 0)
    },
    getTotalPoints () {
      return this.items.reduce((prev, element) => prev + element.point * element.quantity, 0)
    },
    usedDiscount () {
      let cash = parseInt(this.UserCash)
      let discount = parseInt(this.discount)
      if (discount > cash) {
        window.alert('您扣抵的金額超過回饋金，請輸入正確的金額。')
      } else {
        this.current_discount = discount
        this.UserCash = cash - discount
        this.discountInput = true
      }
    },
    changeDelivery () {
      let points = this.getTotalPoints()
      // 購買點數超過運費且有設定滿額免運
      if (points >= this.freeDelivery && this.free_delivery_set === 1) {
        this.shippingOptions = [
          { text: '請選擇', value: 0, tx: 'option' },
          { text: '宅配到府', value: 0, tx: 'send_to_home_free' },
          { text: '郵局', value: 0, tx: 'post' }
        ]
      } else {
        this.shippingOptions = [
          { text: '請選擇', value: 0, tx: 'option' },
          { text: '宅急便', value: this.deliveryPricing.c_domestic, tx: 'send_to_home' },
          { text: '郵局', value: this.deliveryPricing.p_domestic, tx: 'post' }
        ]
      }
    },
    nextStep () {
      let str = ''
      this.calculateFee()
      if (this.shippinged === 'option') {
        str += '請選擇配送方式。\n'
      } else if (!this.userID || !this.token) {
        str += '請先登入會員再進行結帳\n'
      } else if (this.items.length === 0) {
        str += '請先選擇商品。\n'
      }
      if (str === '') {
        this.step1 = false
        this.step2 = true
      } else {
        window.alert(str)
      }
    },
    onSubmit () {
      let str = ''
      if (this.userName === '' || typeof this.userName === 'undefined') {
        str += '請填寫姓名。\n'
      } else if (this.UserPhone === '' || typeof this.UserPhone === 'undefined') {
        str += '請先填寫連絡電話。\n'
      } else if (this.paymented === '') {
        str += '請先選擇付款方式。\n'
      } else if (this.discount > 0 && this.discountInput === false) {
        str += '請先按下確認扣抵。\n'
      } else if (this.countyval === 0 && this.districtval === 0) {
        str += '請先填寫配送地址。\n'
      }
      if (str === '') {
        this.flag = true
        this.$store.dispatch('CHECKOUT')
        document.getElementById('order-form').submit()
      } else {
        window.alert(str)
      }
    },
    calculateFee () {
      let total = this.getTotal()
      if (total < this.freeDelivery && this.free_delivery_set === 1 || this.free_delivery_set === 0) {
        this.shippingFee = this.deliveryPricing.c_domestic
      } else {
        this.shippingFee = 0
      }
    },
    addToCart (row) {
      this.$store.dispatch('SAVE_ACTIVITY_ITEM', row.id)
      this.$store.dispatch('ADD_TO_CART', row)
    }
  },
  mounted: function () {
    let fid = (this.items) ? this.items[0].fid : ''
    this.countyval = this.$store.getters.getUserCounty
    this.userName = this.$store.getters.getUserName
    this.district = this.districtData[this.countyval - 1]
    this.UserCash = this.$store.getters.getUserCash
    this.userID = this.$store.getters.getUserID

    // 設定各家廠商運費
    let company = JSON.parse(localStorage.getItem('companies'))
    let factory = company.find(function (item, index, array) {
      return item.m_factoryID === fid
    })
    this.deliveryPricing = JSON.parse(factory.delivery)
    // console.log('store free:' + factory.delivery)
    this.free_delivery_set = factory.free_delivery_set
    if (factory.free_delivery_set === 1) {
      this.freeDelivery = factory.free_delivery
    }
    this.changeDelivery()
    this.calculateFee()
  }
}
</script>



// WEBPACK FOOTER //
// ShoppingCart.vue?1371a31d